import { useTranslation } from "react-i18next";
import { Grid4 } from "iconsax-react";
import { runtimeConfig } from "@/shared/config/runtime";
import { useAppDispatch, useAppSelector, useBreadcrumbs } from "@/shared/hooks";
import { Breadcrumbs, Button } from "@/shared/ui";
import { toggleSidebar, selectSidebarCollapsed } from "@/features/settings";
import { NotificationBell } from "@/features/notifications";
import { DemoBadge, DemoDataControls } from "@/features/demo";
import ProfileMenu from "./ProfileMenu";

export default function Header() {
  const dispatch = useAppDispatch();
  const breadcrumbs = useBreadcrumbs();
  const collapsed = useAppSelector(selectSidebarCollapsed);
  const { t } = useTranslation("Sidebar");

  return (
    <header className="sticky top-0 z-[100] surface-secondary-fill w-full pt-1 pb-4 flex justify-between items-center">
      <div className="flex items-center gap-3">
        <Button
          variant={collapsed ? "primary" : "secondary"}
          aria-label={t("toggleSidebar")}
          className="ml-1 w-10 h-10 flex justify-center items-center p-1! rounded-md!"
          onClick={() => dispatch(toggleSidebar())}>
          <span className={collapsed ? "" : "content-base-secondary"}>
            <Grid4 size={20} color="currentColor" />
          </span>
        </Button>
        {breadcrumbs.length > 0 && (
          <>
            <span className="w-px h-6 bg-alpha-black-10" />
            <Breadcrumbs items={breadcrumbs} />
          </>
        )}
        {runtimeConfig.isDemo && (
          <>
            <span className="w-px h-6 bg-alpha-black-10" />
            <DemoBadge />
          </>
        )}
      </div>

      <div className="flex justify-end items-center gap-3 relative">
        {runtimeConfig.isDemo && <DemoDataControls />}
        <NotificationBell />
        <ProfileMenu />
      </div>
    </header>
  );
}
